var $ = require('../jCube');

module.exports =  {

    render: function(element) {
        var container, dom;
        var _el = element;

        function canBeNamed (tag_name) {
            var arr = ['button', 'fieldset', 'form', 'iframe', 'input', 'map', 'meta', 'object', 'output', 'param', 'select', 'textarea'];
            return arr.indexOf(tag_name) > -1;
        }

        container = document.createElement('div');
        container.className = 'form-group';

        if(!$.isEmptyValue('container', _el)){

            if(!$.isEmptyValue('className', _el.container)) {
                container.className += ' ' + _el.container['className'];
            }

        }

        if(!$.isEmptyValue('label', _el)) {
            container.appendChild(this.label(_el));
        }

        dom = document.createElement(_el.tagName);

        if(!$.isEmptyValue('render', _el)) {
            dom = _el.render(dom);
        }

        if (!$.isEmptyValue('id', _el)) {
            dom.setAttribute('id', _el.id);
        }

        if (!$.isEmptyValue('name', _el) && canBeNamed(_el.tagName)) {
            container.className += ' field-' + _el.name;
            dom.setAttribute('name', _el.name);
        }

        if (!$.isEmptyValue('className', _el)) {
            dom.className = _el.className;
        }

        if (!$.isEmptyValue('subType', _el)) {
            dom.setAttribute('type', _el.subType);
        }

        if (!$.isEmptyValue('innerHTML', _el)) {
            dom.innerHTML = _el.innerHTML;
        }

        if(!$.isEmptyValue('children', _el)) {
            for (var i = 0; i < _el.children.length; ++i){
                if(_el.children[i] !== null) {
                    dom.appendChild(this.render(_el.children[i]));
                }
            }
        }

        if(_el.frame === false) {
            return dom;
        }

        container.appendChild(dom);
        return container;
    },

    label: function(element) {
        var label = document.createElement('label');
        label.htmlFor = element.id;         // TODO: check isset

        var require = '';
        if(element.validation.required === true){
            require = '<span class="fb-required">*</span>';
        }

        label.innerHTML = element.label + require;

        return label;
    }
};